import React, { useRef, useEffect } from 'react';
import './Hero.css';

const Hero = () => {
  const videoRef = useRef(null);

  useEffect(() => {
    const video = videoRef.current;
    if (video) {
      // Set playback quality settings for smooth playback
      video.defaultPlaybackRate = 1.0;
      video.playbackRate = 1.0;
      
      // Increase buffer size for smoother playback
      if (video.buffered && video.buffered.length > 0) {
        // Wait for more data to buffer before playing
        video.addEventListener('progress', () => {
          if (video.buffered.length > 0) {
            const bufferedEnd = video.buffered.end(video.buffered.length - 1);
            const currentTime = video.currentTime;
            // If we have at least 3 seconds buffered ahead, we're good
            if (bufferedEnd - currentTime > 3 && video.paused) {
              video.play().catch(() => {});
            }
          }
        }, { once: false });
      }
      
      // Force load video
      video.load();
      
      // Function to play video
      const playVideo = async () => {
        try {
          if (video.paused) {
            await video.play();
          }
        } catch (error) {
          console.error('Error playing video:', error);
        }
      };
      
      // Handle waiting event (when video stalls)
      const handleWaiting = () => {
        // Pause briefly to let buffer catch up
        if (!video.paused) {
          video.pause();
          setTimeout(() => {
            if (video.readyState >= 3) {
              video.play().catch(() => {});
            }
          }, 100);
        }
      };
      
      // Handle playing event (when video resumes)
      const handlePlaying = () => {
        // Video is playing smoothly
      };
      
      video.addEventListener('waiting', handleWaiting);
      video.addEventListener('playing', handlePlaying);
      
      // Try to play when video is ready
      const tryPlayWhenReady = () => {
        if (video.readyState >= 4) { // HAVE_ENOUGH_DATA
          playVideo();
          return true;
        }
        return false;
      };
      
      // Listen for events - wait for enough data
      const handleCanPlayThrough = () => {
        playVideo();
      };
      
      video.addEventListener('canplaythrough', handleCanPlayThrough, { once: true });
      
      // Try immediately if already loaded
      let timeoutId;
      if (!tryPlayWhenReady()) {
        // Also try after a delay
        timeoutId = setTimeout(playVideo, 500);
      }
      
      // Error handler
      video.addEventListener('error', (e) => {
        const error = video.error;
        if (error) {
          console.error('Video error:', error.code, error.message);
        }
      });
      
      return () => {
        // Cleanup
        if (timeoutId) {
          clearTimeout(timeoutId);
        }
        video.removeEventListener('waiting', handleWaiting);
        video.removeEventListener('playing', handlePlaying);
        video.removeEventListener('canplaythrough', handleCanPlayThrough);
        if (video) {
          video.pause();
        }
      };
    }
  }, []);

  return (
    <div id="home" className="container-fluid pl-0 pr-0 clearfix" 
         style={{minHeight: '100vh', display: 'flex', flexDirection: 'column', position: 'relative', background: 'transparent'}}>
      <video 
        ref={videoRef}
        autoPlay 
        loop 
        muted 
        playsInline
        preload="auto"
        webkit-playsinline="true"
        onError={(e) => {
          const error = e.target.error;
          if (error) {
            console.error('Video error:', error.code, error.message);
          }
        }}
        onCanPlay={() => {
          const video = videoRef.current;
          if (video) {
            video.play().catch(err => console.error('Play error:', err));
          }
        }}
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          zIndex: 0,
          backgroundColor: '#000',
          pointerEvents: 'none',
          transform: 'scale(1.07)',
          transformOrigin: 'center center'
        }}
      >
        <source src={`${process.env.PUBLIC_URL || ''}/videos/VR_Showreel_for_Site.webm`} type="video/webm" />
        <source src="/videos/VR_Showreel_for_Site.webm" type="video/webm" />
        Your browser does not support the video tag.
      </video>
      <div className="container-fluid position-relative px-5" style={{flex: 1, minHeight: 'calc(100vh - 80px)', zIndex: 1}}>
        <div className="position-absolute" style={{left: '3rem', bottom: '100px', maxWidth: '676px', zIndex: 2}}>
          <div className="wow bounceInRight">
            <h3 className="text-white mb-3">
              VR TRAINING THAT SHORTENS LEARNING CYCLES AND MAKES EVERY EMPLOYEE JOB-READY FASTER.
            </h3>
            <p className="lead text-white mb-4 d-none d-md-block"></p>
            <a 
              href="#contact" 
              className="btn text-uppercase btn-lg wow bounceInUp btn-demo"
              style={{
                backgroundColor: '#ff6600',
                borderColor: '#ff6600',
                color: '#fff',
                borderRadius: 0
              }}
            >
              Request a demo
            </a>
          </div>
        </div>
        <div className="position-absolute text-right" style={{right: '3rem', top: '100px', maxWidth: '780px', zIndex: 2}}>
          <div className="wow bounceInLeft">
            <p className="lead text-white mb-0">
              WE CREATE REALISTIC VR ENVIRONMENTS THAT REDUCE TRAINING TIME, CUT COSTS, AND LET TEAMS PRACTICE CRITICAL SKILLS WITHOUT RISK OR DOWNTIME.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;

